// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Poppins&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 991px) {
  .side-image {
    position: relative;
    height: 300px; }
  .list-items-container .list-item {
    width: 50%; }
  .white-popup-block {
    margin: 80px auto; }
  button.mfp-close {
    position: absolute;
    right: 50%;
    margin-right: -24px;
    top: -60px; }
  .mfp-close:active {
    top: -59px; }
  .blog-detail-contents {
    margin: 0;
    padding: 30px 0; } }

@media (max-width: 767px) {
  .module {
    padding: 80px 0; }
  .list-items-container .list-item {
    width: 100%; }
  .callout {
    text-align: center; }
  .side-image-text {
    padding-left: 15px;
    padding-right: 15px; }
  .mouse-icon {
    display: none; }
  .module-title span {
    font-size: 40px;
    top: -10px; }
  .iconbox {
    margin: 30px auto 60px; }
  .carousel-control {
    display: none; } }

@media (max-width: 480px) {
  h1 {
    font-size: 34px;
    letter-spacing: 3px; }
  h2 {
    font-size: 24px !important;
    margin: 0 0 30px !important;
    letter-spacing: 3px !important; }
  .company {
    text-align: left !important; }
    .company h2 {
      margin-left: -50px !important; }
    .company h3 {
      margin-left: -50px !important; }
    .company h4 {
      margin-left: -50px !important; }
    .company h5 {
      margin-left: -50px !important; }
    .company h6 {
      margin-left: -50px !important; }
  .contentFormat {
    margin-left: -50px !important; } }

.iconbox {
  background: #fff none repeat scroll 0 0;
  padding: 50px 20px;
  position: relative;
  text-align: center;
  max-width: 340px;
  margin: 30px auto;
  box-shadow: -6px 10px 40px rgba(0, 0, 0, 0.06); }

.iconbox-icon {
  color: #116466;
  position: absolute;
  left: 0;
  right: 0;
  top: -35px;
  height: 80px;
  width: 80px;
  margin: 0 auto;
  background: #fff;
  display: block;
  line-height: 80px;
  border-radius: 50px;
  font-size: 30px;
  box-shadow: -6px 10px 40px rgba(0, 0, 0, 0.06); }

.module {
  padding: 120px 0 100px; }

.module-gray {
  background: #f5f5f5; }

.iconbox-text {
  padding-top: 30px; }

.iconbox-title {
  margin: 0 0 15px;
  padding: 0; }

.iconbox-desc {
  font: 400 12px/1.8 'Poppins', sans-serif;
  color: #5b5963;
  overflow-x: hidden; }

h1,
h2,
h3,
h4,
h5,
h6 {
  font: 700 40px/1.2 'Poppins', sans-serif;
  text-transform: uppercase;
  letter-spacing: 5px;
  margin: 5px 0 5px;
  color: #5b5963; }

h2 {
  font-size: 30px;
  margin: 0 0 30px; }

h3 {
  font-size: 13px;
  letter-spacing: 1px;
  margin: 0 0 5px; }

h4 {
  font-size: 12px;
  letter-spacing: 1px; }

h5 {
  font-size: 12px;
  letter-spacing: 1px;
  font-weight: 400; }

h6 {
  font-size: 11px;
  letter-spacing: 1px;
  font-weight: 400; }
`, "",{"version":3,"sources":["webpack://./src/store/components/skills/index.scss"],"names":[],"mappings":"AAEA;EAEC;IACC,kBAAkB;IAClB,aAAa,EAAA;EAGd;IACC,UAAU,EAAA;EAGX;IACC,iBAAiB,EAAA;EAGlB;IACC,kBAAkB;IAClB,UAAU;IACV,mBAAmB;IACnB,UAAU,EAAA;EAGX;IACC,UAAU,EAAA;EAGX;IACC,SAAS;IACT,eAAe,EAAA,EACf;;AAGF;EAEC;IACC,eAAe,EAAA;EAGhB;IACC,WAAW,EAAA;EAGZ;IACC,kBAAkB,EAAA;EAGnB;IACC,kBAAkB;IAClB,mBAAmB,EAAA;EAGpB;IACC,aAAa,EAAA;EAEd;IACC,eAAe;IACf,UAAU,EAAA;EAEX;IACC,sBAAsB,EAAA;EAGvB;IACC,aAAa,EAAA,EACb;;AAIF;EAEC;IACC,eAAe;IACf,mBAAmB,EAAA;EAGpB;IACC,0BAAyB;IACzB,2BAA0B;IACpB,8BAA6B,EAAA;EAGjC;IACI,2BAA0B,EAAA;IAD9B;MAGQ,6BAA4B,EAAA;IAHpC;MAMQ,6BAA4B,EAAA;IANpC;MASQ,6BAA4B,EAAA;IATpC;MAYQ,6BAA4B,EAAA;IAZpC;MAeQ,6BAA4B,EAAA;EAIpC;IACI,6BAA4B,EAAA,EAC/B;;AAIL;EACI,uCAAuC;EACvC,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,8CAA8C,EAAA;;AAGlD;EACI,cAAc;EACd,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,8CAA8C,EAAA;;AAElD;EACI,sBAAsB,EAAA;;AAE1B;EACI,mBAAmB,EAAA;;AAEvB;EACI,iBAAiB,EAAA;;AAGrB;EACI,gBAAgB;EAChB,UAAU,EAAA;;AAGd;EACI,wCAAwC;EACxC,cAAc;EACd,kBAAkB,EAAA;;AAEtB;;;;;;EAMI,wCAAwC;EACxC,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc,EAAA;;AAGlB;EACI,eAAe;EACf,gBAAgB,EAAA;;AAGpB;EACI,eAAe;EACf,mBAAmB;EACnB,eAAe,EAAA;;AAGnB;EACI,eAAe;EACf,mBAAmB,EAAA;;AAGvB;EACI,eAAe;EACf,mBAAmB;EACnB,gBAAgB,EAAA;;AAGpB;EACI,eAAe;EACf,mBAAmB;EACnB,gBAAgB,EAAA","sourcesContent":["@import url('https://fonts.googleapis.com/css?family=Poppins&display=swap');\n\n@media (max-width: 991px) {\n\n\t.side-image {\n\t\tposition: relative;\n\t\theight: 300px;\n\t}\n\n\t.list-items-container .list-item {\n\t\twidth: 50%;\n\t}\n\n\t.white-popup-block {\n\t\tmargin: 80px auto;\n\t}\n\n\tbutton.mfp-close {\n\t\tposition: absolute;\n\t\tright: 50%;\n\t\tmargin-right: -24px;\n\t\ttop: -60px;\n\t}\n\n\t.mfp-close:active {\n\t\ttop: -59px;\n\t}\n\n\t.blog-detail-contents {\n\t\tmargin: 0;\n\t\tpadding: 30px 0;\n\t}\n}\n\n@media (max-width: 767px) {\n\n\t.module {\n\t\tpadding: 80px 0;\n\t}\n\n\t.list-items-container .list-item {\n\t\twidth: 100%;\n\t}\n\n\t.callout {\n\t\ttext-align: center;\n\t}\n\n\t.side-image-text {\n\t\tpadding-left: 15px;\n\t\tpadding-right: 15px;\n\t}\n\n\t.mouse-icon {\n\t\tdisplay: none;\n\t}\n\t.module-title span {\n\t\tfont-size: 40px;\n\t\ttop: -10px;\n\t}\n\t.iconbox{\n\t\tmargin: 30px auto 60px;\n\t}\n\n\t.carousel-control{\n\t\tdisplay: none;\n\t}\n\n}\n\n@media (max-width: 480px) {\n\n\th1 {\n\t\tfont-size: 34px;\n\t\tletter-spacing: 3px;\n\t}\n\n\th2 {\n\t\tfont-size: 24px!important;\n\t\tmargin: 0 0 30px!important;\n        letter-spacing: 3px!important;\n    }\n\n    .company {\n        text-align: left!important;\n        h2 {\n            margin-left: -50px!important;\n        }\n        h3 {\n            margin-left: -50px!important;\n        }\n        h4 {\n            margin-left: -50px!important;\n        }\n        h5 {\n            margin-left: -50px!important;\n        }\n        h6 {\n            margin-left: -50px!important;\n        }\n    }\n    \n    .contentFormat {\n        margin-left: -50px!important;\n    }\n\n}\n\n.iconbox {\n    background: #fff none repeat scroll 0 0;\n    padding: 50px 20px;\n    position: relative;\n    text-align: center;\n    max-width: 340px;\n    margin: 30px auto;\n    box-shadow: -6px 10px 40px rgba(0, 0, 0, 0.06);\n}\n\n.iconbox-icon {\n    color: #116466;\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: -35px;\n    height: 80px;\n    width: 80px;\n    margin: 0 auto;\n    background: #fff;\n    display: block;\n    line-height: 80px;\n    border-radius: 50px;\n    font-size: 30px;\n    box-shadow: -6px 10px 40px rgba(0, 0, 0, 0.06);\n}\n.module {\n    padding: 120px 0 100px;\n}\n.module-gray {\n    background: #f5f5f5;\n}\n.iconbox-text {\n    padding-top: 30px;\n}\n\n.iconbox-title {\n    margin: 0 0 15px;\n    padding: 0;\n}\n\n.iconbox-desc {\n    font: 400 12px/1.8 'Poppins', sans-serif;\n    color: #5b5963;\n    overflow-x: hidden;\n}\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n    font: 700 40px/1.2 'Poppins', sans-serif;\n    text-transform: uppercase;\n    letter-spacing: 5px;\n    margin: 5px 0 5px;\n    color: #5b5963;\n}\n\nh2 {\n    font-size: 30px;\n    margin: 0 0 30px;\n}\n\nh3 {\n    font-size: 13px;\n    letter-spacing: 1px;\n    margin: 0 0 5px;\n}\n\nh4 {\n    font-size: 12px;\n    letter-spacing: 1px;\n}\n\nh5 {\n    font-size: 12px;\n    letter-spacing: 1px;\n    font-weight: 400;\n}\n\nh6 {\n    font-size: 11px;\n    letter-spacing: 1px;\n    font-weight: 400;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
